import { Collapse, Divider, Grid, Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import { useState } from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import { ExpandCollapseButton } from "../../../reporting/report-lists/reports/components/ExpandCollapseButton";
import type { SelectedCompany } from "../../hooks/validationStateSlice";

interface Props {
  company: SelectedCompany;
  summary?: React.ReactElement;
  children?: React.ReactNode;
}

const CompanyContent = ({ company, children, summary }: PropsWithChildren<Props>) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <Grid container sx={{ width: "100%" }}>
      <Stack sx={{ flex: 1, width: "100%" }}>
        <Stack direction="row" sx={{ alignItems: "center", flexGrow: 1, pl: 1.5, pr: 2, pb: 0.5 }}>
          <ExpandCollapseButton expanded={isExpanded} onClick={setIsExpanded} />
          <Typography sx={{ color: "text.primary" }}>{company.dashboards.length} Dashboards</Typography>
          <HorizontalFill />
          {summary}
        </Stack>
        <Collapse in={isExpanded}>
          <Divider />
          <Stack
            spacing={1}
            useFlexGap
            sx={{
              p: 1.5,
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
              width: "100%",
            }}
          >
            {children}
          </Stack>
        </Collapse>
      </Stack>
    </Grid>
  );
};

export default CompanyContent;
